<template>
    <div>

        <h3>{{ formSubmissionNotificationsTitle }}</h3>
        <p>{{ formSubmissionNotificationsDescription }}</p>

        <form class="form-inline">
            <div class="form-group">
                <input type="email" class="form-control new_email_input" placeholder="Email" v-model="newEmail">
            </div>
            <button type="submit" class="btn btn-success" @click="storeEmail($event)">Add</button>
        </form>

        <snappy-table
            ref="table"
            :endpoint="url"
            :endpoint-exclude-fleet="true"
            :columns="['email', 'actions']"
            :headings="['Email Address', 'Actions']"
            :templated-slot-names="['email', 'actions']"
            record-type="Form Submission Notificaction Email Addresses"
            :search-hidden="true"
            :no-results-message="noResultsMessage"
        >
            <template #email="{ row }">
                <div class="d-flex">
                    {{ row.email }}
                </div>
            </template>

            <template #actions="{ row }">
                <div class="d-flex">
                    <button
                        class="btn btn-danger"
                        title="Delete"
                        v-tooltip="'Delete Email Address'"
                        @click="onDeleteButtonClick($event, row)"
                    >
                        <i class="fas fa-fw fa-trash"></i>
                    </button>
                </div>
            </template>
        </snappy-table>
    </div>
</template>

<script>
import SnappyTable from '../../../components/SnappyTable';
import axios from "axios";
import swal from "sweetalert2";
import * as Sentry from "@sentry/vue";

export default {
    name: 'notifications-emails',
    props: {
        url: {
            type: String,
            required: true,
        },
        emailableType: {
            type: String,
            required: true,
        },
        emailableId: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: false,
        },
        formSubmissionNotificationsTitle: {
            type: String,
            required: true,
        },
        formSubmissionNotificationsDescription: {
            type: String,
            required: true,
        },
        noResultsMessage: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            newEmail: '',
        };
    },
    components: {
        SnappyTable
    },
    methods: {
        resetNewEmail() {
            this.newEmail = '';
        },
        refreshTable() {
            this.$refs.table.refresh();
        },
        handleError(error) {
            const {data} = error.response || {};
            if (data && data.errors && data.errors.email) {
                swal.fire({
                    title: 'UhOh!',
                    text: data.errors.email[0],
                    type: 'error',
                    confirmButtonText: 'Ok',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-lg btn-primary'
                });
            } else {
              Sentry.captureException(error);
            }
        },
        onDeleteButtonClick(event, email) {
            event.stopPropagation();

            let url = '/api/?entity=email-notification&action=delete&emailable_type=' + this.emailableType + '&emailable_id=' + this.emailableId + '&email_id=' + email.id;

            axios.delete(url).then(() => {
                this.refreshTable();
            }).catch((error) => {
                $.notify('Request failed! Try again later.', 'error');
                Sentry.captureException(error);
            });
        },
        storeEmail(event) {
            event.preventDefault();
            event.stopPropagation();

            if (this.newEmail) {
                let url = '/api/?entity=email-notification&action=store&emailable_type=' + this.emailableType + '&emailable_id=' + this.emailableId;

                axios.post(url, {
                    email: this.newEmail,
                }).then((result) => {
                    this.resetNewEmail();
                    this.refreshTable();
                }).catch((error) => {
                    this.handleError(error);
                });
            }
        }
    }
};
</script>

<style lang="scss">
.modal {

    .modal-body {

        form > .form-group {
            margin: auto;
        }
    }
}
</style>
